import { render, staticRenderFns } from "./questionBankList.vue?vue&type=template&id=45a48557&scoped=true&"
import script from "./questionBankList.vue?vue&type=script&lang=js&"
export * from "./questionBankList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a48557",
  null
  
)

export default component.exports